import { esc } from '@/utils/escape';

export function generateTrustHTML(data: any, settings: any): string {
  const items = (data.items || [])
    .map(
      (item: any) => `        <div class="trust__item">
          <div class="trust__value">${esc(item.value)}</div>
          <div class="trust__label">${esc(item.label)}</div>
        </div>`,
    )
    .join("\n");

  return `  <!-- Trust Bar -->
  <section class="trust">
    <div class="container">
      <div class="trust__inner">
${items}
      </div>
    </div>
  </section>`;
}
